/* feresmar-tarjeta.js — stepper y "Agregar" de la tarjeta, para contenedores
 * .fm-tarjetas (la portada).
 * ---------------------------------------------------------------------------
 * OJO con el alcance. En la página de colección, feresmar-filtros ya trae su
 * propio manejador y lo engancha a #fm-fgrid, no a document. Este archivo se
 * engancha SOLO a .fm-tarjetas, y a #fm-fgrid NO se le pone esa clase: si
 * ambos manejadores vieran el mismo clic, "Agregar" mandaría el producto al
 * carrito dos veces.
 *
 * La lógica es la misma que la de feresmar-filtros (misma llamada a
 * /cart/add.js, misma sincronización de la burbuja y del cajón del carrito)
 * para que agregar desde la portada se comporte igual que desde la colección.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  function sincronizarCarrito() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-organizer-bubble]').forEach(function (b) {
          b.textContent = ' ' + cart.item_count + ' ';
          if (cart.item_count > 0) b.classList.remove('visually-hidden');
          else b.classList.add('visually-hidden');
        });
        return fetch('/cart')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return cart;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var nuevo = tmp.querySelector('#cart-items');
            var actual = document.querySelector('#cart-items');
            if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
            return cart;
          });
      })
      .catch(function () {});
  }

  function enganchar(caja) {
    if (caja.dataset.ffTarjetaLista === '1') return;   // no enganchar dos veces
    caja.dataset.ffTarjetaLista = '1';

    caja.addEventListener('click', function (e) {
      var qb = e.target.closest('.fmm-qty_btn');
      if (qb) {
        var inp = qb.parentNode.querySelector('.fmm-qty_input');
        var val = parseInt(inp.value, 10) || 1;
        if (qb.dataset.act === 'mas') val++; else val = Math.max(1, val - 1);
        inp.value = val;
        return;
      }
      var b = e.target.closest('.fmm-add');
      if (!b) return;
      e.preventDefault();
      var card = b.closest('.fmm-card');
      var qinp = card ? card.querySelector('.fmm-qty_input') : null;
      var cant = qinp ? (parseInt(qinp.value, 10) || 1) : 1;
      b.disabled = true;
      b.textContent = 'Agregando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(b.dataset.vid), quantity: cant })
      })
        .then(function (r) { if (!r.ok) throw 0; })
        .then(function () {
          b.textContent = 'Agregado ✓';
          sincronizarCarrito();
          setTimeout(function () { b.disabled = false; b.textContent = 'Agregar'; }, 1600);
        })
        .catch(function () { b.disabled = false; b.textContent = 'Reintentar'; });
    });
  }

  function iniciar() { document.querySelectorAll('.fm-tarjetas').forEach(enganchar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  // El editor de temas reinyecta secciones sin recargar la página.
  document.addEventListener('shopify:section:load', iniciar);
})();
